module.exports = __webpack_public_path__ + "img/A4.e1a42508.png";